
/**
 * 프로젝트 메타 정보
 */
export type ProjectListResponsePageAllOfThreeContentItemMetaInfo = {
  tags?: string[];
};
